import React from 'react'
import { Grid, Typography } from '@mui/material'
import JC from '../media/JC.png'

const versionLocal = 'V 1.0.0'

export const Footer = () => {
    return (
        <Grid
            container
            direction="row"
            size={{ xs: 12 }}
            sx={{
                justifyContent: "center",
                alignItems: "center",
            }}
            className='footer'
            spacing={1}
        >
            <img src={JC} alt="" style={{ maxWidth: '200px' }} onClick={() => window.open("https://www.jcinformatics.com/", "_blank")} />
            <Typography variant='caption'>&nbsp;{versionLocal}</Typography>
        </Grid>
    )
}
